import React from "react";
import { normalizeExtraInfoValue, formatNumberText } from "./extraInfo.utils";
import * as tagSelectors from '../../../shared/db/tags-labels-selectors';
import styles from "./extra-info.module.scss";

const getFormattedText = (
  text: string | undefined,
  kind: string | undefined,
  valueType: string | undefined,
  formatNumbersByKind?: boolean
) => {
  if (valueType === 'money') return formatNumberText(text);
  if (formatNumbersByKind && (kind === 'number' || kind === 'money')) return formatNumberText(text);
  return text;
};

export const formatCategory = (
  value: any,
  infos: any,
  currentLabels: Record<string, string> | undefined,
  openGallery: (files: any[], i: number) => void,
  formatNumbersByKind?: boolean
) => {
  const categoryEntries = Object.entries(value)
    .filter(([key]) => key !== "isCategory")
    .map(([id, val]) => {
      if (
        val == null ||
        val === "" ||
        (typeof val === "object" && Object.keys(val).length === 0)
      ) {
        return null;
      }

      let label = id;
      if (infos?.[id]?.details?.name) label = infos[id].details.name;
      else if (currentLabels && currentLabels[id]) label = currentLabels[id];

      const { text, date, files, boolean: booleanValue } = normalizeExtraInfoValue(val);
      const labelId =
        tagSelectors.mapNameToIdValue(label, infos) ?? label;
      const kind = (infos[labelId]?.details as any)?.kind;
      const valueType = (infos[labelId]?.details as any)?.valueType;
      const formattedText = getFormattedText(text, kind, valueType, formatNumbersByKind);

      let valueContent: React.ReactNode = null;
      if (kind === 'boolean') {
        valueContent = <>{booleanValue ? 'Yes' : 'No'}</>;
      } else if (formattedText) valueContent = <>{formattedText}</>;
      if ((valueType === 'money' || kind === 'money') && formattedText) {
        valueContent = <>${formattedText}</>;
      }
      if (date)
        valueContent = valueContent ? (
          <>
            {valueContent} <span className={styles.separator}>|</span> {date}
          </>
        ) : (
          <>{date}</>
        );
      if (files?.length) {
        const button = (
          <button
            onClick={() => openGallery(files, 0)}
            title="Open file"
            style={{
              padding: 0,
              margin: 0,
              marginLeft: 4,
              textDecoration: "underline",
              fontWeight: "bold",
              whiteSpace: "nowrap",
            }}
          >
            {files.length === 1 ? "File" : "Files"}
          </button>
        );
        valueContent = valueContent ? (
          <>
            {valueContent} <span className={styles.separator}>|</span> {button}
          </>
        ) : (
          button
        );
      }
      if (!valueContent) valueContent = "-";

      return (
        <div key={id} className={styles.gridRow}>
          <div className={styles.gridCell}>{label}:</div>
          <div className={styles.gridCellLast}>{valueContent}</div>
        </div>
      );
    })
    .filter(Boolean);

  return <>{categoryEntries}</>;
};

export const formatLabelForGrid = (
  [name, value]: [string, any],
  index: number,
  infos: any,
  authUser: any,
  currentLabels: Record<string, string> | undefined,
  openGallery: (files: any[], i: number) => void,
  formatNumbersByKind?: boolean
) => {
  if (name.toLowerCase() === "gps") return null;

  if (value && typeof value === "object" && value.isCategory) {
    return (
      <React.Fragment key={name}>
        {formatCategory(value, infos, currentLabels, openGallery, formatNumbersByKind)}
      </React.Fragment>
    );
  }

  const { text, date, files, boolean: booleanValue } = normalizeExtraInfoValue(value);
  const labelId = tagSelectors.mapNameToIdValue(name, infos) || name;
  const kind = (infos[labelId]?.details as any)?.kind;
  const valueType = (infos[labelId]?.details as any)?.valueType;
  const formattedText = getFormattedText(text, kind, valueType, formatNumbersByKind);

  let valueContent: React.ReactNode = null;
  if (kind === 'boolean') {
    valueContent = <>{booleanValue ? 'Yes' : 'No'}</>;
  } else if (formattedText) valueContent = <>{formattedText}</>;
    if ((valueType === 'money' || kind === 'money') && formattedText) {
        valueContent = <>${formattedText}</>;
  }
  if (date)
    valueContent = valueContent ? (
      <>
        {valueContent} <span className={styles.separator}>|</span> {date}
      </>
    ) : (
      <>{date}</>
    );
  if (files?.length) {
    const button = (
      <button
        onClick={() => openGallery(files, 0)}
        title="Open file"
        style={{
          padding: 0,
          margin: 0,
          marginLeft: 4,
          textDecoration: "underline",
          fontWeight: "bold",
          color:"blue",
          whiteSpace: "nowrap",
        }}
      >
        {files.length === 1 ? "File" : "Files"}
      </button>
    );
    valueContent = valueContent ? (
      <>
        {valueContent} <span className={styles.separator}>|</span> {button}
      </>
    ) : (
      button
    );
  }
  if (!valueContent) valueContent = "-";

  return (
    <div key={name} className={styles.gridRow}>
      <div className={styles.gridCell}>{name}:</div>
      <div className={styles.gridCellLast}>{valueContent}</div>
    </div>
  );
};
